import EmbodimentGenerator from './EmbodimentGenerator.vue';
import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { EmbodimentModel } from './models/embodiment-model';
import { EmbodimentModelImpl } from './models/impls/embodiment-model';
import { EmbodimentRulesModel } from './models/embodiment-rules-model';
import { EmbodimentRulesModelImpl } from './models/impls/embodiment-rules-model';
import { EmbodimentClaimFeaturesModel } from './models/embodiment-claim-features-model';
import { EmbodimentClaimFeaturesModelImpl } from './models/impls/embodiment-claim-features-model';
import { EmbodimentHistoryModel } from './models/embodiment-history-model';
import { EmbodimentHistoryModelImpl } from './models/impls/embodiment-history-model';
import { EmbodimentService } from './service/embodiment-service';
import { EmbodimentServiceImpl } from './service/impls/embodiment-service';
import { EmbodimentHistoryService } from './service/embodiment-history-service';
import { EmbodimentHistoryServiceImpl } from './service/impls/embodiment-history-service';
import { EmbodimentRulesService } from './service/embodiment-rules-service';
import { EmbodimentRulesServiceImpl } from './service/impls/embodiment-rules-service';
import { EmbodimentClaimFeaturesService } from './service/embodiment-claim-features-service';
import { EmbodimentClaimFeaturesServiceImpl } from './service/impls/embodiment-claim-features-service';
import { EmbodimentFeatureKeywordsService } from './service/embodiment-feature-keywords-service';
import { EmbodimentFeatureKeywordsServiceImpl } from './service/impls/embodiment-feature-keywords-service';

const embodimentGeneratorModule = (bind: interfaces.Bind) => {
    bind(EmbodimentModel).to(EmbodimentModelImpl);
    bind(EmbodimentRulesModel).to(EmbodimentRulesModelImpl);
    bind(EmbodimentClaimFeaturesModel).to(EmbodimentClaimFeaturesModelImpl);
    bind(EmbodimentHistoryModel).to(EmbodimentHistoryModelImpl);
    bind(EmbodimentService).to(EmbodimentServiceImpl);
    bind(EmbodimentHistoryService).to(EmbodimentHistoryServiceImpl);
    bind(EmbodimentRulesService).to(EmbodimentRulesServiceImpl);
    bind(EmbodimentClaimFeaturesService).to(EmbodimentClaimFeaturesServiceImpl);
    bind(EmbodimentFeatureKeywordsService).to(EmbodimentFeatureKeywordsServiceImpl);
};

export {
    EmbodimentGenerator,
    embodimentGeneratorModule,
};
